import React from "react";
import Investortable from "./List/InvestorFqList";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const index = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Investortable />
      </div>
    </div>
  );
};

export default index;
